import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/doctocat/doctocat/theme/src/components/layout.js";
import { Box } from '@primer/react';
import { Contributors } from '@primer/gatsby-theme-doctocat';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<h2>{`Site metadata`}</h2>
<p>{`You can customize your site's metadata via the `}<inlineCode parentName="p">{`siteMetadata`}</inlineCode>{` object in `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  siteMetadata: {
    // Used for page titles and SEO
    title: 'My Site',
    // Used in the header
    shortName: 'My Site',
    // Used for the main link and the logo link in the header
    header: {
      title: 'Primer',
      url: 'https://primer.style',
      logoUrl: 'https://primer.style',
    },
    // Used for SEO
    description: 'My site description',
    // Used for social previews
    imageUrl: 'https://user-images.githubusercontent.com/example-image.png',
  },
}
`}</code></pre>
<h2>{`Side navigation`}</h2>
<p>{`Side navigation for your site is generated from the content in `}<inlineCode parentName="p">{`src/@primer/gatsby-theme-doctocat/nav.yml`}</inlineCode>{`. Edit that file to customize your side navigation. Each entry in `}<inlineCode parentName="p">{`nav.yml`}</inlineCode>{` should have a `}<inlineCode parentName="p">{`title`}</inlineCode>{` and either a `}<inlineCode parentName="p">{`url`}</inlineCode>{` or a `}<inlineCode parentName="p">{`children`}</inlineCode>{` list to create a group of links:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-yml"
      }}>{`# src/@primer/gatsby-theme-doctocat/nav.yml
- title: Example
  children:
    - title: Example 2
      url: /example/example-2
`}</code></pre>
<p>{`Entries with `}<inlineCode parentName="p">{`children`}</inlineCode>{` cannot also have a `}<inlineCode parentName="p">{`url`}</inlineCode>{`.`}</p>
<Note variant="warning" mdxType="Note">
  Doctocat supports a maximum of two levels of nesting.
</Note>
<h2>{`Repository`}</h2>
<p>{`Doctocat has a few features that rely on information about your repository, including:`}</p>
<ul>
<li parentName="ul">{`"Edit this page on GitHub" links on the bottom of every page`}</li>
<li parentName="ul">{`Contributors on the bottom of every page`}</li>
<li parentName="ul">{`Repository link in the sidebar`}</li>
</ul>
<p>{`To enable these features, you'll need to specify your site's `}<a parentName="p" {...{
        "href": "https://docs.npmjs.com/files/package.json#repository"
      }}><inlineCode parentName="a">{`repository`}</inlineCode></a>{` in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`// package.json
{
  "repository": "repo-owner/repo-name"
}
`}</code></pre>
<h2>{`Subdirectories`}</h2>
<p>{`If your site is located in a subdirectory of a repository, you'll also need to provide the relative path to the root of your git repository via the `}<inlineCode parentName="p">{`repoRootPath`}</inlineCode>{` option in `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    {
      resolve: '@primer/gatsby-theme-doctocat',
      options: {
        repoRootPath: '..', // defaults to '.'
      },
    },
  ],
}
`}</code></pre>
<h2>{`Default branch`}</h2>
<p>{`If your site uses a branch other than `}<inlineCode parentName="p">{`master`}</inlineCode>{` for your default branch, you'll also need to let Doctocat know via the `}<inlineCode parentName="p">{`defaultBranch`}</inlineCode>{` option in `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    {
      resolve: '@primer/gatsby-theme-doctocat',
      options: {
        defaultBranch: 'main', // defaults to 'master'
      },
    },
  ],
}
`}</code></pre>
<h2>{`Contributors`}</h2>
<p>{`If you have the `}<inlineCode parentName="p">{`repository`}</inlineCode>{` in `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` and `}<inlineCode parentName="p">{`repoRootPath`}</inlineCode>{` in `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{` set up correctly (as described `}<a parentName="p" {...{
        "href": "#edit-on-github-link"
      }}>{`above`}</a>{`), Doctocat will automatically display contributors on the bottom of every page, like so:`}</p>
<Box borderWidth="1px" borderStyle="solid" borderColor="border.default" borderRadius={2} p={4} mb={3} mdxType="Box">
  <Contributors contributors={[{
        login: 'colebemis',
        latestCommit: {
          url: '#',
          date: '2019-08-15T23:40:19Z'
        }
      }, {
        login: 'emplums',
        latestCommit: {
          url: '#',
          date: '2019-08-14T00:19:54Z'
        }
      }]} mdxType="Contributors" />
</Box>
<p>{`These contributors are determined by commits. However, we know that commits aren't the only way to contribute. You can use `}<a parentName="p" {...{
        "href": "/usage/front-matter#additional-contributors"
      }}>{`front matter`}</a>{` to give credit to people who aren't listed in the commit history but still contributed.`}</p>
<h2>{`Hero`}</h2>
<p>{`To add a hero section to a page, you'll need to override the default layout component with Doctocat's `}<inlineCode parentName="p">{`HeroLayout`}</inlineCode>{` component by exporting it from your MDX file:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-markdown"
      }}>{`// index.mdx
import {HeroLayout} from '@primer/gatsby-theme-doctocat'
export default HeroLayout
`}</code></pre>
<p><inlineCode parentName="p">{`HeroLayout`}</inlineCode>{` is similar to the default layout component except it also renders a `}<inlineCode parentName="p">{`Hero`}</inlineCode>{` component displaying the `}<inlineCode parentName="p">{`title`}</inlineCode>{` and `}<inlineCode parentName="p">{`description`}</inlineCode>{` defined in the `}<inlineCode parentName="p">{`siteMetadata`}</inlineCode>{` object from `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Hero />
`}</code></pre>
<p>{`To use a custom hero component, `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/blog/2019-04-29-component-shadowing/"
      }}>{`shadow`}</a>{` Doctocat's default `}<inlineCode parentName="p">{`Hero`}</inlineCode>{` component by creating a `}<inlineCode parentName="p">{`hero.js`}</inlineCode>{` file in `}<inlineCode parentName="p">{`src/@primer/gatsby-theme-doctocat/components`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// src/@primer/gatsby-theme-doctocat/components/hero.js
import {Box} from '@primer/react'
import React from 'react'

export default function Hero() {
  return (
    <Box bg="black" p={5}>
      My Custom Hero
    </Box>
  )
}
`}</code></pre>
<h2>{`Favicon`}</h2>
<p>{`If you want to override the default favicon, you can pass a relative path to a custom icon as a theme option in your `}<inlineCode parentName="p">{`gatsby-config.js`}</inlineCode>{`:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// gatsby-config.js
module.exports = {
  plugins: [
    {
      resolve: '@primer/gatsby-theme-doctocat',
      options: {
        icon: './src/images/custom-icon-512.png', // This path is relative to the root of the site.
      },
    },
  ],
}
`}</code></pre>
<p>{`Doctocat uses `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/packages/gatsby-plugin-manifest/"
      }}><inlineCode parentName="a">{`gatsby-plugin-manifest`}</inlineCode></a>{` to generate a pre-configured set of icons from your image. For best results, if you’re providing an icon for generation, it should be:`}</p>
<ul>
<li parentName="ul">{`512x512 pixels or larger.`}</li>
<li parentName="ul">{`Square. If it’s not, the image will be `}<a parentName="li" {...{
          "href": "https://en.wikipedia.org/wiki/Letterboxing_(filming)"
        }}>{`letterboxed`}</a>{` with a transparent background.`}</li>
<li parentName="ul">{`JPEG, PNG, WebP, TIFF, GIF, or SVG format.`}</li>
</ul>
<h2>{`MDX components`}</h2>
<p>{`Doctocat uses `}<a parentName="p" {...{
        "href": "https://mdxjs.com/"
      }}>{`MDX`}</a>{` to allow you to embed React components in your markdown files and provides a few React `}<a parentName="p" {...{
        "href": "/components"
      }}>{`components`}</a>{` that are globally available in all `}<inlineCode parentName="p">{`.md`}</inlineCode>{` and `}<inlineCode parentName="p">{`.mdx`}</inlineCode>{` files (no import required). To add custom components to this list of globally available components, create an `}<inlineCode parentName="p">{`mdx-components.js`}</inlineCode>{` file in `}<inlineCode parentName="p">{`src/@primer/gatsby-theme-doctocat/`}</inlineCode>{` and export your custom components from this file:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// src/@primer/gatsby-theme-doctocat/mdx-components.js
import {SomeComponent} from 'path/to/some-component'

export default {
  SomeComponent,
}
`}</code></pre>
<pre><code parentName="pre" {...{
        "className": "language-md"
      }}>{`---
title: Some markdown file
---

You can now use your component in any markdown file like so:

<SomeComponent />
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      